import React from 'react';

function Hero() {
  return (
    <section id="home" className="hero-bg">
      <div className="max-w-7xl mx-auto px-6">
        <h1 className="hero-title">
          Precision in Marine Claims Adjustment.<br />Global Expertise, Singapore Integrity.
        </h1>
        <p style={{ marginTop: '1rem', fontSize: '1.25rem', maxWidth: '48rem' }}>
          We deliver accurate average adjusting, detailed vessel inspections,
          and strategic claims advisory for the world's leading maritime
          stakeholders.
        </p>
        <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem' }}>
          <a href="./claims" className="btn-primary" style={{ width: 'fit-content' }}>Initiate Service Request</a>
          <a href="#claims-center" className="btn-secondary" style={{ width: 'fit-content' }}>Go to Claims Center</a>
        </div>
      </div>
    </section>
  );
}

export default Hero;